import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M1.012.54h10.123c.4 0 .723.323.723.722v13.842a.362.362 0 0 1-.553.307l-5.231-3.28-5.231 3.28a.361.361 0 0 1-.554-.307V1.262c0-.4.324-.723.723-.723Zm9.4 1.445H1.735v11.16l4.339-2.72 4.338 2.72V1.984Z"
    />
  </svg>
)
export default SvgComponent